<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<!-- Creator: CorelDRAW 2020 (64-Bit) -->
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 5291.66 2116.66"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">
 <g id="Layer_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer"/>
  <path  d="M813.64 2036.28c1137.72,0 1418.15,129.06 1724.42,-1185.51l215.54 0c306.27,1314.57 586.7,1185.51 1724.42,1185.51 714.12,0 1094.67,-1939.95 215.53,-1939.95 -1884.68,0 -1358.26,-138.35 -2047.72,323.32 -689.46,-461.67 -163.04,-323.32 -2047.72,-323.32 -879.14,0 -498.59,1939.95 215.53,1939.95z"/>
 </g>
</svg>
